export default __webpack_public_path__ + "static/media/shopify-logo.554bda41.svg";